/* src/app/webtree-website/ai-resume-screener/ai-resume-screener.component.scss */
.resume-screener-banner {
  width: auto;
  height: auto;
  background-image: url("./media/ai-sourcing-bg-6FJCZCO2.png");
  background-repeat: no-repeat;
  background-position: left top;
  background-size: cover;
  padding: 22px 40px;
  margin: 0 -16px;
}
.resume-screener-banner .webbtree-logo {
  margin-bottom: 15px;
}
.resume-screener-banner .headerText {
  width: 70%;
  text-align: center;
  margin: 0 auto;
}
.resume-screener-banner .headerText h1 {
  font-size: 36px;
  font-weight: 600;
  line-height: 1.4;
  background:
    linear-gradient(
      90.94deg,
      #57E7FB 36.44%,
      #ED1EAF 102.68%);
  color: transparent;
  background-clip: text;
  margin-bottom: 20px;
}
.resume-screener-banner .ai-insights-box {
  width: 30%;
  margin: 0 auto;
  border-radius: 16px;
  padding: 15px 25px;
  background:
    linear-gradient(
      91.17deg,
      rgba(255, 255, 255, 0.1) 52.83%,
      rgba(255, 255, 255, 0.1) 99%);
  border: 1px solid;
  border-color: #7FB1E7;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
}
.resume-screener-banner .ai-insights-box i {
  font-size: 20px;
  color: #80BFFF;
  margin-bottom: 10px;
}
.resume-screener-banner .ai-insights-box .insightText {
  font-size: 10px;
  color: #fff;
  margin-bottom: 0;
}
.resume-screener-banner .ai-insights-box span {
  color: #fff;
}
.resume-screener-banner .ai-resume-screening-btn {
  margin-bottom: 30px;
}
.page-body {
  width: auto;
  height: auto;
  margin: 0 -16px;
  background-color: #FBFBFB;
}
.page-body .page-title {
  text-align: center;
  padding: 40px 40px 0px 40px;
}
.page-body .page-title h2 {
  font-size: 24px;
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 0px;
  color: #484b59;
}
.page-body .page-title p {
  font-size: 18px;
  font-weight: 400;
  line-height: 1.5;
  margin-bottom: 0px;
  color: #484b59;
}
.page-body .form-component {
  padding: 40px;
}
.page-body .form-section {
  background-color: #FBFBFB;
}
.page-body .form-section .text-steps {
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 5px;
  color: #484b59;
}
.page-body .form-section .step-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #484b59;
}
.page-body .form-section .ai-screen-form-input {
  border-radius: 2px;
  border: 1px solid #d9d9d9;
  font-size: 14px;
  line-height: 1.2;
  padding: 6px 12px;
  height: 36px;
  width: 100%;
}
.page-body .form-section textarea.ai-screen-form-input {
  padding: 12px;
  border-radius: 12px;
  min-height: 150px;
}
.page-body .form-section .ats-upload-btn {
  width: 100%;
  border: dashed 0.5px #2e93a1;
  color: #2e93a1;
  display: flex;
  box-sizing: border-box;
  position: relative;
  background-color: #ECF0F4;
  border-radius: 5px;
  height: 150px;
}
.page-body .form-section .learnmorebox {
  background:
    linear-gradient(
      90deg,
      rgba(255, 245, 134, 0) 2.65%,
      #FFF586 100%);
}
.page-body .easy-step-box {
  background-color: #fff;
  padding: 60px;
}
.page-body .easy-step-box h2 {
  color: #484b59;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
  margin-bottom: 32px;
}
.page-body .easy-step-box .step-conatiner {
  width: 75%;
  margin: 0 auto;
}
.page-body .easy-step-box .easy-step-card {
  width: calc(25% - 20px);
  border-radius: 8px;
  background-color: rgba(188, 255, 226, 0.3019607843);
  border: 1px solid;
  border-image-source:
    linear-gradient(
      180deg,
      #2E93A1 0%,
      #B3E8EF 100%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  margin-right: 20px;
  height: 200px;
}
.page-body .easy-step-box .easy-step-card:last-child {
  margin-right: 0;
}
.page-body .easy-step-box .easy-step-card .fa-light {
  display: block;
  transition: display 0.4s ease-in;
}
.page-body .easy-step-box .easy-step-card .fa-solid {
  display: none;
}
.page-body .easy-step-box .easy-step-card i {
  color: #0C5B66;
  font-size: 20px;
  margin-bottom: 10px;
}
.page-body .easy-step-box .easy-step-card .steps {
  font-size: 14px;
  color: #0C5B66;
  margin-bottom: 10px;
}
.page-body .easy-step-box .easy-step-card .step-text {
  color: #04535E;
  font-size: 14px;
  font-weight: 500;
}
.page-body .easy-step-box .easy-step-card .learnmore {
  font-size: 12px;
  font-weight: 500;
}
.page-body .easy-step-box .easy-step-card .learnmore i {
  font-weight: 400;
  font-size: 10px;
}
.page-body .easy-step-box .easy-step-card:hover .fa-light {
  display: none;
}
.page-body .easy-step-box .easy-step-card:hover .fa-solid {
  display: block;
}
.page-body .powerby-adv-ai-card {
  background-color: #fff;
  padding: 40px;
  background:
    linear-gradient(
      360deg,
      #D7F7EF 5.45%,
      #FFFFFF 38.5%);
}
.page-body .powerby-adv-ai-card .ai-icon-stack {
  display: flex;
}
.page-body .powerby-adv-ai-card .ai-icon-stack .ai-icons {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  overflow: hidden;
}
.page-body .powerby-adv-ai-card .ai-icon-stack .ai-icons img {
  width: 100%;
  height: auto;
}
.page-body .powerby-adv-ai-card .ai-icon-stack .chtgpt {
  z-index: 2;
}
.page-body .powerby-adv-ai-card .ai-icon-stack .ai-icon2 {
  z-index: 1;
  margin-left: -5px;
}
.page-body .img-card {
  width: 100%;
  height: 100%;
  background-color: #FBFBFB;
  border-radius: 16px;
  background-image: url("./media/ai-powered-47TFYTOB.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.page-body .middle-banner {
  width: auto;
  height: auto;
  background-image: url("./media/gb-YDMIB5FS.png");
  background-repeat: no-repeat;
  background-position: left top;
  background-size: cover;
  padding: 40px 20px;
}
.page-body .middle-banner .middle-content {
  width: 80%;
  margin: 0 auto;
  text-align: center;
  font-size: 32px;
  line-height: 1.5;
}
.page-body .middle-banner .middle-content p {
  background:
    linear-gradient(
      90.65deg,
      #AFF3FF 0.56%,
      #FFE477 110.96%);
  background-clip: text;
  color: transparent;
  font-size: 32px;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
  margin-bottom: 0;
}
.page-body .middle-banner .middle-content p.new-content {
  font-size: 28px;
}
.page-body .middle-banner .middle-content .emailForm {
  display: flex;
  align-items: end;
  margin-bottom: 20px;
}
.page-body .middle-banner .middle-content .emailForm .ai-resume-screening-btn {
  width: 180px;
  margin-bottom: 0;
  font-size: 16px;
  padding: 9px 12px;
  border-radius: 0;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}
.page-body .try-this-box {
  padding: 40px;
}
.page-body .try-this-box h2 {
  font-size: 24px;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
  margin-bottom: 30px;
  color: #484B59;
}
.page-body .try-this-box .try-this-card {
  background: #FFFFFF;
  border: 1px solid rgba(72, 75, 89, 0.1019607843);
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.031372549);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.0196078431);
  border-radius: 8px;
  padding: 32px;
  width: calc(33% - 24px);
  margin-right: 24px;
  margin-bottom: 24px;
}
.page-body .try-this-box .try-this-card i,
.page-body .try-this-box .try-this-card span {
  font-size: 20px;
  font-weight: 500;
  line-height: 1.5;
  margin-bottom: 20px;
  display: block;
}
.page-body .try-this-box .try-this-card .try-header {
  font-size: 20px;
  font-weight: 500;
  line-height: 1.5;
  color: #484B59;
  margin-bottom: 8px;
}
.page-body .try-this-box .try-this-card .content {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: #484B59;
}
.page-body .try-this-box .try-this-card:nth-child(3) {
  margin-right: 0;
}
.page-body .try-this-box .try-this-card:nth-child(6) {
  margin-right: 0;
}
.page-footer {
  width: auto;
  height: auto;
  background-image: url("./media/footer-bg-ZCY7KVBU.png");
  background-repeat: no-repeat;
  background-position: left top;
  background-size: cover;
  padding: 60px 22px;
  margin: 0 -16px;
}
.page-footer .footer-content {
  width: 75%;
  margin: 0 auto;
  text-align: center;
}
.page-footer .footer-content h1 {
  font-size: 32px;
  font-weight: 600;
  line-height: 1.5;
  color: #48D0E8;
  margin-bottom: 24px;
}
.page-footer .footer-content p {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin-bottom: 24px;
  color: #ffffff;
}
.page-footer .footer-content .ai-resume-screening-btn {
  padding: 12px 16px;
  border: 1px solid #FDD835;
  color: #fff;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1;
  background-color: #FDD835;
  font-size: 18px;
  font-weight: 500;
  color: #484b59;
  margin-bottom: 24px;
  width: fit-content;
}
.page-footer .footer-content .emailForm {
  display: flex;
}
.page-footer .footer-content .emailForm .ai-resume-screening-btn {
  width: 180px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-radius: 4px;
  font-size: 16px;
  padding: 9px 16px;
}
.page-footer .footer-content p.small {
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  color: #ffffff;
}
.middle-banner2 {
  width: 100%;
  height: auto;
  background-image: url("./media/gb-YDMIB5FS.png");
  background-repeat: no-repeat;
  background-position: left top;
  background-size: cover;
  padding: 40px 20px;
  position: relative;
}
.screener-container {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.screener-container .screeningtime {
  display: flex;
}
.screener-container .screeningtime .screentime-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 60%;
}
.screener-container .screeningtime .screentime-content .screen-main-content {
  background:
    linear-gradient(
      90.65deg,
      #AFF3FF 0.56%,
      #FFE477 110.96%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-size: 28px;
  font-weight: 600;
  line-height: 1.5;
  text-align: left;
  margin-bottom: 20px;
  width: 85%;
}
.screener-container .screeningtime .screentime-content .screen-second-content {
  font-weight: 600;
  font-size: 20px;
  line-height: 1.5;
  color: #ffffff;
}
.screener-container .screeningtime .screentime-bookdemo {
  background-image: url("./media/bookdemobutton-2EZJKJWZ.png");
  background-repeat: no-repeat;
  background-position: right top;
  background-size: contain;
  width: 30%;
  height: 100%;
  position: absolute;
  right: 6%;
  top: 0px;
  padding: 40px 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.screener-container .screeningtime .screentime-bookdemo .ai-resume-screening-btn {
  margin-bottom: 0;
}
.ai-resume-screening-btn {
  padding: 12px 16px;
  border: 1px solid #FDD835;
  color: #fff;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1;
  background-color: #FDD835;
  font-size: 18px;
  font-weight: 500;
  color: #484b59;
  margin-bottom: 24px;
  width: fit-content;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .resume-screener-banner {
    background-size: 100% 100%;
  }
  .resume-screener-banner .webbtree-logo {
    margin-bottom: 55px;
  }
  .resume-screener-banner .headerText {
    width: 90%;
  }
  .resume-screener-banner .ai-insights-box {
    width: 55%;
  }
  .page-body .page-title {
    padding: 40px 60px 0 60px;
    margin-bottom: 0;
  }
  .page-body .easy-step-box {
    padding: 16px;
  }
  .page-body .easy-step-box .step-conatiner {
    width: 65%;
    margin: 0 auto;
    flex-wrap: wrap;
    display: flex;
    justify-content: center;
  }
  .page-body .easy-step-box .step-conatiner .easy-step-card {
    width: calc(50% - 20px);
    margin-bottom: 20px;
  }
  .page-body .easy-step-box .step-conatiner .easy-step-card:nth-child(2) {
    margin-right: 0px;
  }
  .page-body .easy-step-box .step-conatiner .easy-step-card:nth-child(4) {
    margin-right: 0px;
  }
  .page-body .middle-banner {
    padding: 40px 20px;
  }
  .page-body .middle-banner .middle-content {
    width: 100%;
    font-size: 24px;
  }
  .page-body .middle-banner .middle-content p {
    font-size: 24px;
  }
  .page-body .middle-banner .middle-content p.new-content {
    font-size: 24px;
  }
  .page-body .try-this-box {
    padding: 16px;
  }
  .page-body .try-this-box .try-this-card {
    width: calc(50% - 24px);
  }
  .page-body .try-this-box .try-this-card:nth-child(2) {
    margin-right: 0;
  }
  .page-body .try-this-box .try-this-card:nth-child(3) {
    margin-right: 24px;
  }
  .page-body .try-this-box .try-this-card:nth-child(4) {
    margin-right: 0;
  }
  .page-body .try-this-box .try-this-card:nth-child(6) {
    margin-right: 0;
  }
  .page-footer .footer-content {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
  .screener-container {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  .screener-container .screeningtime {
    display: flex;
  }
  .screener-container .screeningtime .screentime-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 60%;
  }
  .screener-container .screeningtime .screentime-content .screen-main-content {
    background:
      linear-gradient(
        90.65deg,
        #AFF3FF 0.56%,
        #FFE477 110.96%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-size: 28px;
    font-weight: 600;
    line-height: 1.5;
    text-align: left;
    margin-bottom: 20px;
    width: 85%;
  }
  .screener-container .screeningtime .screentime-content .screen-second-content {
    font-weight: 600;
    font-size: 20px;
    line-height: 1.5;
    color: #ffffff;
  }
  .screener-container .screeningtime .screentime-bookdemo {
    background-image: url("./media/bookdemobutton-2EZJKJWZ.png");
    background-repeat: no-repeat;
    background-position: right top;
    background-size: contain;
    width: 30%;
    height: 100%;
    position: absolute;
    right: 6%;
    top: 0px;
    padding: 40px 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .screener-container .screeningtime .screentime-bookdemo .ai-resume-screening-btn {
    margin-bottom: 0;
  }
}
@media only screen and (min-width: 769px) and (max-width: 991px) {
  .resume-screener-banner {
    background-size: 100% 100%;
  }
  .resume-screener-banner .webbtree-logo {
    margin-bottom: 55px;
  }
  .resume-screener-banner .headerText {
    width: 90%;
  }
  .resume-screener-banner .ai-insights-box {
    width: 55%;
  }
  .page-body .page-title {
    padding: 40px 60px 0 60px;
    margin-bottom: 0;
  }
  .page-body .easy-step-box {
    padding: 16px;
  }
  .page-body .easy-step-box .step-conatiner {
    width: 65%;
    margin: 0 auto;
    flex-wrap: wrap;
    display: flex;
    justify-content: center;
  }
  .page-body .easy-step-box .step-conatiner .easy-step-card {
    width: calc(50% - 20px);
    margin-bottom: 20px;
  }
  .page-body .easy-step-box .step-conatiner .easy-step-card:nth-child(2) {
    margin-right: 0px;
  }
  .page-body .easy-step-box .step-conatiner .easy-step-card:nth-child(4) {
    margin-right: 0px;
  }
  .page-body .powerby-adv-ai-card .img-card {
    width: 100%;
    background-position: 80%;
  }
  .page-body .middle-banner {
    padding: 40px 20px;
  }
  .page-body .middle-banner .middle-content {
    width: 100%;
    font-size: 24px;
  }
  .page-body .middle-banner .middle-content p {
    font-size: 24px;
  }
  .page-body .middle-banner .middle-content p.new-content {
    font-size: 24px;
  }
  .page-body .try-this-box {
    padding: 16px;
  }
  .page-body .try-this-box .try-this-card {
    width: calc(50% - 24px);
  }
  .page-body .try-this-box .try-this-card:nth-child(2) {
    margin-right: 0;
  }
  .page-body .try-this-box .try-this-card:nth-child(3) {
    margin-right: 24px;
  }
  .page-body .try-this-box .try-this-card:nth-child(4) {
    margin-right: 0;
  }
  .page-body .try-this-box .try-this-card:nth-child(6) {
    margin-right: 0;
  }
  .page-footer .footer-content {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
  .page-footer .footer-content .emailForm {
    display: flex;
  }
  .page-footer .footer-content .emailForm .ai-resume-screening-btn {
    width: 180px;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    font-size: 16px;
    padding: 9px 16px;
  }
  .screener-container {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  .screener-container .screeningtime {
    display: flex;
  }
  .screener-container .screeningtime .screentime-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 50%;
  }
  .screener-container .screeningtime .screentime-content .screen-main-content {
    background:
      linear-gradient(
        90.65deg,
        #AFF3FF 0.56%,
        #FFE477 110.96%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-size: 28px;
    font-weight: 600;
    line-height: 1.5;
    text-align: left;
    margin-bottom: 20px;
    width: 85%;
  }
  .screener-container .screeningtime .screentime-content .screen-second-content {
    font-weight: 600;
    font-size: 20px;
    line-height: 1.5;
    color: #ffffff;
  }
  .screener-container .screeningtime .screentime-bookdemo {
    background-image: url("./media/bookdemobutton-2EZJKJWZ.png");
    background-repeat: no-repeat;
    background-position: right top;
    background-size: cover;
    width: 42%;
    height: 100%;
    position: absolute;
    right: 6%;
    top: 0px;
    padding: 40px 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .screener-container .screeningtime .screentime-bookdemo .ai-resume-screening-btn {
    margin-bottom: 0;
  }
}
@media only screen and (min-width: 576px) and (max-width: 768px) {
  .resume-screener-banner {
    background-size: 100% 100%;
  }
  .resume-screener-banner .webbtree-logo {
    margin-bottom: 55px;
  }
  .resume-screener-banner .headerText {
    width: 90%;
  }
  .resume-screener-banner .ai-insights-box {
    width: 55%;
  }
  .page-body .page-title {
    padding: 40px 60px 0 60px;
    margin-bottom: 0;
  }
  .page-body .easy-step-box {
    padding: 16px;
  }
  .page-body .easy-step-box .step-conatiner {
    width: 80%;
    margin: 0 auto;
    flex-wrap: wrap;
    display: flex;
    justify-content: center;
  }
  .page-body .easy-step-box .step-conatiner .easy-step-card {
    width: calc(50% - 20px);
    margin-bottom: 20px;
  }
  .page-body .easy-step-box .step-conatiner .easy-step-card:nth-child(2) {
    margin-right: 0px;
  }
  .page-body .easy-step-box .step-conatiner .easy-step-card:nth-child(4) {
    margin-right: 0px;
  }
  .page-body .powerby-adv-ai-card .img-card {
    width: 100%;
    height: 310px;
    background-position: 80%;
  }
  .page-body .middle-banner {
    padding: 40px 20px;
  }
  .page-body .middle-banner .middle-content {
    width: 100%;
    font-size: 24px;
  }
  .page-body .middle-banner .middle-content p {
    font-size: 24px;
  }
  .page-body .middle-banner .middle-content p.new-content {
    font-size: 22px;
  }
  .page-body .try-this-box {
    padding: 16px;
  }
  .page-body .try-this-box .try-this-card {
    width: calc(50% - 24px);
  }
  .page-body .try-this-box .try-this-card:nth-child(2) {
    margin-right: 0;
  }
  .page-body .try-this-box .try-this-card:nth-child(3) {
    margin-right: 24px;
  }
  .page-body .try-this-box .try-this-card:nth-child(4) {
    margin-right: 0;
  }
  .page-body .try-this-box .try-this-card:nth-child(6) {
    margin-right: 0;
  }
  .page-footer .footer-content {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
  .page-footer .footer-content .emailForm {
    display: flex;
  }
  .page-footer .footer-content .emailForm .ai-resume-screening-btn {
    width: 180px;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    font-size: 16px;
    padding: 9px 16px;
  }
  .screener-container {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  .screener-container .screeningtime {
    display: flex;
  }
  .screener-container .screeningtime .screentime-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 50%;
  }
  .screener-container .screeningtime .screentime-content .screen-main-content {
    background:
      linear-gradient(
        90.65deg,
        #AFF3FF 0.56%,
        #FFE477 110.96%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-size: 28px;
    font-weight: 600;
    line-height: 1.5;
    text-align: left;
    margin-bottom: 20px;
    width: 85%;
  }
  .screener-container .screeningtime .screentime-content .screen-second-content {
    font-weight: 600;
    font-size: 20px;
    line-height: 1.5;
    color: #ffffff;
  }
  .screener-container .screeningtime .screentime-bookdemo {
    background-image: url("./media/bookdemobutton-2EZJKJWZ.png");
    background-repeat: no-repeat;
    background-position: right top;
    background-size: cover;
    width: 42%;
    height: 100%;
    position: absolute;
    right: 2%;
    top: 0px;
    padding: 40px 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .screener-container .screeningtime .screentime-bookdemo .ai-resume-screening-btn {
    margin-bottom: 0;
  }
}
@media only screen and (max-width: 575px) {
  .resume-screener-banner {
    padding: 40px 16px;
    background-size: 100% 100%;
  }
  .resume-screener-banner .webbtree-logo {
    margin-bottom: 55px;
  }
  .resume-screener-banner .headerText {
    width: 100%;
  }
  .resume-screener-banner .ai-insights-box {
    width: 100%;
  }
  .page-body .page-title {
    padding: 40px 16px 0 16px;
    margin-bottom: 0;
  }
  .page-body .form-component {
    padding: 40px 16px 40px 16px;
  }
  .page-body .easy-step-box {
    padding: 16px 16px;
  }
  .page-body .easy-step-box .xs-scrollable-div {
    width: 100%;
    overflow: auto;
  }
  .page-body .easy-step-box .xs-scrollable-div .step-conatiner {
    width: 1000px;
  }
  .page-body .easy-step-box .xs-scrollable-div .step-conatiner .easy-step-card {
    width: calc(25% - 20px);
  }
  .page-body .middle-banner {
    padding: 30px 16px;
  }
  .page-body .middle-banner .middle-content {
    width: 100%;
    font-size: 22px;
  }
  .page-body .middle-banner .middle-content p {
    font-size: 22px;
  }
  .page-body .middle-banner .middle-content p.new-content {
    font-size: 22px;
  }
  .page-body .middle-banner .middle-content .emailForm {
    display: flex;
    align-items: end;
    margin-bottom: 20px;
    flex-direction: column;
  }
  .page-body .middle-banner .middle-content .emailForm .ai-resume-screening-btn {
    width: 100%;
    margin-bottom: 0;
    font-size: 16px;
    padding: 9px 12px;
    border-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
    margin-top: 20px;
  }
  .page-body .powerby-adv-ai-card .img-card {
    width: 100%;
    height: 310px;
    background-position: 80%;
  }
  .page-body .try-this-box {
    padding: 16px;
  }
  .page-body .try-this-box .try-this-card {
    width: calc(100% - 24px);
    margin-right: 0px;
  }
  .page-body .try-this-box .try-this-card:nth-child(2) {
    margin-right: 0;
  }
  .page-body .try-this-box .try-this-card:nth-child(3) {
    margin-right: 0px;
  }
  .page-body .try-this-box .try-this-card:nth-child(4) {
    margin-right: 0;
  }
  .page-body .try-this-box .try-this-card:nth-child(6) {
    margin-right: 0;
  }
  .page-footer .footer-content {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
  .page-footer .footer-content h1 {
    font-size: 24px;
  }
  .page-footer .footer-content .emailForm {
    display: flex;
    flex-direction: column;
  }
  .page-footer .footer-content .emailForm .ai-resume-screening-btn {
    width: 100%;
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
    border-radius: 4px;
    font-size: 16px;
    padding: 9px 16px;
    text-align: center;
    margin-top: 20px;
  }
  .screener-container {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  .screener-container .screeningtime {
    display: flex;
    flex-direction: column;
  }
  .screener-container .screeningtime .screentime-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
  }
  .screener-container .screeningtime .screentime-content .screen-main-content {
    background:
      linear-gradient(
        90.65deg,
        #AFF3FF 0.56%,
        #FFE477 110.96%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-size: 28px;
    font-weight: 600;
    line-height: 1.5;
    text-align: left;
    margin-bottom: 20px;
    width: 100%;
  }
  .screener-container .screeningtime .screentime-content .screen-second-content {
    font-weight: 600;
    font-size: 20px;
    line-height: 1.5;
    color: #ffffff;
  }
  .screener-container .screeningtime .screentime-bookdemo {
    background-image: url("./media/bookdemobutton-2EZJKJWZ.png");
    background-repeat: no-repeat;
    background-position: right top;
    background-size: cover;
    width: 100%;
    height: 282px;
    position: relative;
    right: 2%;
    top: 0px;
    padding: 40px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .screener-container .screeningtime .screentime-bookdemo .ai-resume-screening-btn {
    margin-bottom: 0;
  }
}
/*# sourceMappingURL=ai-resume-screener.component-YAF4RJJ4.css.map */
